<template>
  <div>
    <div v-if="rule.config.direction == 1">
      Avg. 13F Ranking is &gt;= the lowest Avg. 13F Ranking of the past
      {{ rule.config.number_of_quarters }} quarters.
    </div>
    <div v-else>
      Avg. 13F Ranking is &lt;= the lowest Avg. 13F Ranking of the past
      {{ rule.config.number_of_quarters }} quarters.
    </div>
    <span v-if="rule.config.change_min && rule.config.change_min.trim().length > 0">
      minimum % change of {{ rule.config.change_min }}% from prior quarter.
    </span>

    <span
      v-if="
        rule.config.ranking_min &&
        rule.config.ranking_min.trim().length > 0 &&
        rule.config.ranking_max &&
        rule.config.ranking_max.trim().length > 0
      "
    >
      Avg Ranking between {{ rule.config.ranking_min }} and {{ rule.config.ranking_max }}.
    </span>
    <span v-else-if="rule.config.ranking_min && rule.config.ranking_min.trim().length > 0">
      Avg Ranking &gt;= {{ rule.config.ranking_min }}.
    </span>
    <span v-else-if="rule.config.ranking_max && rule.config.ranking_max.trim().length > 0">
      Avg Ranking &lt;= {{ rule.config.ranking_max }}.
    </span>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {}
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {}
}
</script>
